import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom"

// Route-level error boundary page. Deliberately theme-independent: it renders
// when the app tree (including providers) may have crashed.
export function RouteErrorPage() {
  const error = useRouteError()
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error)

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        backgroundColor: "#0d1117",
        color: "#e6edf3",
        fontFamily: "system-ui, sans-serif",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "18px", fontWeight: 600 }}>Something went wrong</div>
      <div
        style={{ fontSize: "13px", color: "#8b949e", maxWidth: "480px", wordBreak: "break-word" }}
      >
        {message}
      </div>
      <Link to="/inventory" style={{ fontSize: "13px", color: "#3b9b63" }}>
        Back to Master Inventory
      </Link>
    </div>
  )
}
